import { createAsyncThunk } from '@reduxjs/toolkit'
import { setCurrPage } from './sideBarSlice'
import { indexedDBVersion } from '../common/indexedDBVersion'
import { 
    setChat, 
    pushCurrChatMessage, 
    pushCurrChatMessageCount,
    setZeroCurrChatMessageCount,
    incrementCurrChatRefusalCount,
    advanceCurrChatStage,
    setCurrChatAtStartRef,
    setZeroCurrChatRefusalCount,
    setTargetChatSessionName, 
    setTargetChatMessageCaps,
    incrementGivenStageMessageCap,
    toggeleTargetIsMinimized,
    setTargetOnMoveStage,
    checkTargetListItem,
 } from './chatSlice'
import { 
    pushMessage, 
    addMessageCount,
    setZeroMessageCount,
    incrementRefusalCount,
    advanceStage,
    setAtStartRef,
    setZeroRefusalCount,
    setSessionName,
    updateMessageCaps,
    incrementMessageCap,
    toggleIsMinimized,
    setOnMoveStage,
    checkListItem,
 } from './currChatSlice'

export const addChatToDB = createAsyncThunk('chat/addChatToDB', async (arg, { dispatch, getState }) => {
  const emptyStart = arg;
  dispatch(setChat(emptyStart))

  // update the DB
  let dbReq = indexedDB.open("chathistory", indexedDBVersion);

  dbReq.onsuccess = function (evt) {
      let db = dbReq.result;
      if (!db.objectStoreNames.contains('chats')) {
          return;
      }
      const tx = db.transaction('chats', 'readwrite');
      const store = tx.objectStore('chats');
      store.add(emptyStart);
  }

  const currPage = getState().sideBar.currentPage
  if (currPage !== 'home') {
      dispatch(setCurrPage('home'));
  }
})

export const loadChatFromDB = createAsyncThunk('chat/loadChatFromDB', async (_, { dispatch }) => {
  const loadDbReq = indexedDB.open("chathistory", indexedDBVersion);
  loadDbReq.onsuccess = async function (evt) {
    const db = loadDbReq.result;
    if (!db.objectStoreNames.contains('chats')) {
        return;
    }

    const tx = await db.transaction('chats', 'readonly');
    const store = tx.objectStore('chats');
    const dbChatsObj = await store.getAll();
    dbChatsObj.onsuccess = () => {
        const dbChats = dbChatsObj.result;
        for (const dbChat of dbChats) {
            dispatch(setChat(dbChat));
        }
    }
    tx.oncomplete = () => {
        db.close();
    }
}
    loadDbReq.onerror = (err) => {
        console.log(err);
    }
})

export const deteleChatInDB = createAsyncThunk('chat/deleteChatInDB', async (arg) => {
    const delDbReq = indexedDB.open("chathistory", indexedDBVersion);
    delDbReq.onsuccess = async function (evt) {
        let db = delDbReq.result;
        if (!db.objectStoreNames.contains('chats')) {
            return;
        }
        const tx = await db.transaction('chats', 'readwrite');
        const store = tx.objectStore('chats');
        store.delete(arg);
    }
})

export const pushMessagesSync = createAsyncThunk('chat/pushMessagesSync', async (content, { dispatch, getState }) => {
    const currChatStage = getState().currChat.stage
    const sessionId = getState().currChat.sessionId
    dispatch(pushMessage({ stage: currChatStage, content }))
    dispatch(pushCurrChatMessage({ sessionId, stage: currChatStage, content }))
    dispatch(saveCurrChatToDB())
})

export const incrementMessageCountSync = createAsyncThunk('chat/incrementMessageCountSync', async (_, { dispatch, getState }) => {
    const stage = getState().currChat.stage
    const sessionId =  getState().currChat.sessionId
    dispatch(addMessageCount(stage))
    dispatch(pushCurrChatMessageCount({ sessionId, stage }))
    dispatch(saveCurrChatToDB())
})

export const setZeroMessageCountSync = createAsyncThunk('chat/setZeroMessageCountSync', async (_, { dispatch, getState }) => {
    const stage = getState().currChat.stage
    const sessionId =  getState().currChat.sessionId
    dispatch(setZeroMessageCount(stage))
    dispatch(setZeroCurrChatMessageCount({ sessionId, stage }))
    dispatch(saveCurrChatToDB())
})

export const incrementMessageCapSync = createAsyncThunk('chat/incrementMessageCapSync', async (_, { dispatch, getState }) => {
    const stage = getState().currChat.stage
    const sessionId =  getState().currChat.sessionId
    dispatch(incrementGivenStageMessageCap({ sessionId, stage }))
    dispatch(incrementMessageCap(stage))
    dispatch(saveCurrChatToDB())
})

export const incrementRefusalCountSync = createAsyncThunk('chat/incrementRefusalCountSync', async (_, { dispatch, getState }) => {
    const sessionId =  getState().currChat.sessionId
    dispatch(incrementRefusalCount())
    dispatch(incrementCurrChatRefusalCount(sessionId))
    dispatch(saveCurrChatToDB())
})

export const setZeroRefusalCountSync = createAsyncThunk('chat/setZeroRefusalCountSync', async (_, { dispatch, getState }) => {
    const sessionId =  getState().currChat.sessionId
    dispatch(setZeroRefusalCount())
    dispatch(setZeroCurrChatRefusalCount(sessionId))
    dispatch(saveCurrChatToDB())
})

export const advanceStageSync = createAsyncThunk('chat/advanceStageSync', async(_, { dispatch, getState }) => {
    const sessionId = getState().currChat.sessionId
    dispatch(advanceStage())
    dispatch(advanceCurrChatStage(sessionId))
    dispatch(saveCurrChatToDB())
})

export const setAtStartRefSync = createAsyncThunk('chat/setAtStartRefSync', async(bool, { dispatch, getState }) => {
    const sessionId = getState().currChat.sessionId
    dispatch(setAtStartRef(bool))
    dispatch(setCurrChatAtStartRef({ sessionId, bool }))
    dispatch(saveCurrChatToDB())
})

export const configChatSessionSync = createAsyncThunk('chat/configChatSessionSync', async (params , { dispatch }) => {
    const {sessionName, messageCap, sessionId, onChat} = params
    dispatch(setTargetChatSessionName({ sessionId, sessionName }))
    dispatch(setTargetChatMessageCaps({ sessionId, messageCap }))
    if (onChat) {
        dispatch(setSessionName(sessionName))
        dispatch(updateMessageCaps(messageCap))
    }
    dispatch(saveSpecificChatToDB(sessionId))
})

export const toggleIsMinimizedSync = createAsyncThunk('chat/toggleIsMinimizedSync', async (_, { dispatch, getState }) => {
    const sessionId = getState().currChat.sessionId
    dispatch(toggleIsMinimized())
    dispatch(toggeleTargetIsMinimized(sessionId))
    dispatch(saveCurrChatToDB())
})

export const setOnMoveStageSync = createAsyncThunk('chat/setOnMoveStageSync', async (param, { dispatch, getState }) => {
    const sessionId = getState().currChat.sessionId
    dispatch(setOnMoveStage(param))
    dispatch(setTargetOnMoveStage({ sessionId, bool: param }))
    dispatch(saveCurrChatToDB())
})

export const checkListItemSync = createAsyncThunk('chat/checkListItemSync', async (param, { dispatch, getState }) => {
    const sessionId = getState().currChat.sessionId
    const stage = getState().currChat.stage
    dispatch(checkListItem({ stage, index: param }))
    dispatch(checkTargetListItem({ sessionId, stage, index: param }))
    dispatch(saveCurrChatToDB())
})

export const saveCurrChatToDB = createAsyncThunk('chat/saveToDB', async (_, { getState }) => {
    const dbReq = indexedDB.open("chathistory", indexedDBVersion);
    const currChat = getState().currChat
    dbReq.onsuccess = function (evt) {
        let db = dbReq.result;
        if (!db.objectStoreNames.contains('chats')) {
            return;
        }
        const tx = db.transaction('chats', 'readwrite');
        const store = tx.objectStore('chats');
        store.put(currChat);
    }
})

export const saveSpecificChatToDB = createAsyncThunk('chat/saveSpecificChatToDB', async (sessionId, { getState }) => {
    const dbReq = indexedDB.open("chathistory", indexedDBVersion)
    const chat = getState().chat.find(session => session.sessionId === sessionId)
    dbReq.onsuccess = function (evt) {
        let db = dbReq.result;
        if (!db.objectStoreNames.contains('chats')) {
            return;
        }
        const tx = db.transaction('chats', 'readwrite');
        const store = tx.objectStore('chats');
        store.put(chat);
    }
})